module.exports = __webpack_public_path__ + "img/affiliateIcons-02.c096f10b.svg";